export const config = {
  apiUrl: 'https://api.debilling.co.uk/api',
  debug: false,
};



// WEBPACK FOOTER //
// ./src/config.js